var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageAdd"},[_c('div',{staticClass:"header"},[_c('myTitleName',{attrs:{"titleName":_vm.title}})],1),_c('div',{staticClass:"content"},[_vm._t("content")],2),_c('div',{staticClass:"footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }